import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { CellContext } from '@tanstack/react-table';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { mapStatusToGenericInvoiceStatus } from '@app/feature/invoice/helper/invoice-status.helper';

export interface InvoiceListStateCellProps
  extends CellContext<InvoiceModel, InvoiceModel['status']> {}

export const InvoiceListStatusCell = (
  props: InvoiceListStateCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const { color, name } = mapStatusToGenericInvoiceStatus(getValue());

  return (
    <Tag className={classNames(color)}>
      <Text italic fontSize={TextFontSize.Small}>
        {t(`delmonicos-shared-sdk.enums-invoice-status.${name}`)}
      </Text>
    </Tag>
  );
};
